<template>
  <div class="enWarehouse">
    <!-- 初始页面 -->
    <div class="init_view">
      <h1 class="title">请选择箱格大小</h1>
      <table class="cell_table">
        <thead>
          <tr>
            <th>箱格尺寸</th>
            <th>小</th>
            <th>中</th>
            <th>大</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>柜子剩余</td>
            <td>{{cells.S}}</td>
            <td>{{cells.M}}</td>
            <td>{{cells.L}}</td>
          </tr>
        </tbody>
      </table>
      <div class="radio_wrap">
        <span class="text">选择箱格大小</span>
        <el-radio v-model="radio" label="S">小</el-radio>
        <el-radio v-model="radio" label="M">中</el-radio>
        <el-radio v-model="radio" label="L">大</el-radio>
      </div>
      <div class="confirm_btn btn" @click.stop="toScan">确认</div>
    </div> 
    <!-- 底部按钮 -->
    <div class="btn_wrap">
      <!-- <div class="bin_btn btn" @click.stop="toReturn">返回</div> -->
      <div class="bin_btn btn"  @click.stop="toList">入库清单</div>
      <div class="exit_btn btn"  @click.stop="toExit">退出登录</div>
    </div>
  </div>
  
</template>

<script>
var _this
import "../../../../static/CEsite/css/common.less"
export default {
  data() {
    return {
      actionType: '',
      cells: {
        S: 42,
        M: 20,
        L: 10,
      },
      radio: 'S',
    };
  },
  created() { // 发起请求，获取当前剩余空闲箱格数据（数量）、如果某类箱格剩余为0，则该类箱格不可选
    this.actionType = this.$route.query.actionType;
    console.warn('投递页actionType：',this.actionType);
  },
  mounted() {
    _this = this;
  },
  methods: {
    // 点击确认，将用户选择的箱格数据(尺寸)提交到后台/设备，
    toScan() {
      console.log('选择的箱格尺寸,radio：',_this.radio);
      _this.$router.push({
        path: '/eSite/enWarehouse/enWarehouseScan',
        query: {actionType: _this.actionType}
      })
    },
    // 进入入库清单
    toList() {
      _this.$router.push({
        path: '/eSite/enWarehouse/enWarehouseList',
        query: {actionType: _this.actionType}
      })
    },
    // 退出登录，清除token
    toExit() {
      _this.$router.push({
        path: '/',
      })
    },
    
  }
}
</script>

<style lang="less">
.init_view {
  width: 55%;
  .title {
    font-size: 0.8rem;
  }
  .cell_table {
    width: 100%;
    margin: 0.3rem 0;
    font-size: 0.4rem;
    border: 1px solid #333;
    th, td {
      text-align: center;
      border: 1px solid #333;
      padding: 0.05rem 0;
      width: 1%;
    }
  }
  .radio_wrap {
    margin-bottom: 0.5rem;
    .el-radio {
      color: #fff;
    }
    span {
      // color: #fff;
      vertical-align: middle;
      font-size: 0.5rem;
    }
    span.text {
      margin-right: 0.3rem;
    }
  }
  .confirm_btn {
    width: 2.9rem;
    height: 0.8rem;
    margin: 0 auto;
    padding-left: 0.1rem; 
    font-size: 0.4rem;
    line-height: 0.8rem;
    letter-spacing: 0.1rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/CEsite/EN-warehouse/index.vue